export default __webpack_public_path__ + "static/media/alien.321040a6.gif";